// Auto-scroll multicolumn carousel on mobile only
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.multicolumn .slider');
  if (!slider) return;

  // Only run on mobile
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  if (!isMobile()) return;

  let index = 0;

  setInterval(() => {
    const items = slider.querySelectorAll('.slider__slide');
    if (!items.length) return;

    index = (index + 1) % items.length;
    const target = items[index];

    // Scroll the SLIDER horizontally, not the page
    slider.scrollTo({
      left: target.offsetLeft - slider.offsetLeft,
      behavior: 'smooth'
    });
  }, 4000);
});